import React from 'react';
import styled from 'styled-components';
import { useFormContext, Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { Input as BaseInput, Form, Message, Icon } from 'semantic-ui-react';
import { map } from 'lodash';
import ServiceGroupSelect from '../../../staff/containers/form/ServiceGroupSelect';

import { FormLabel as BaseFormLabel } from '../../../../components';

import styles from '../../../../styles';

const FormLabel = styled(BaseFormLabel)`
    ${styles.proximaNovaFontFamily} !important;
`;

const Input = styled(BaseInput)`
    & input {
        background-color: ${props =>
            props.readOnly ? '#fffaf3' : '#fff'} !important;
    }
`;

function CabinetForm({ languages, defaultLanguage }) {
    const { control, formState: { errors } } = useFormContext();
    const rootError = errors.root;

    return (
        <Form error={!!rootError}>
            {rootError && (
                <Message error>
                    <Icon name="warning sign" />
                    {rootError.message}
                </Message>
            )}
            <FormLabel>
                <FormattedMessage
                    id="pages.cabinets.form.name"
                    defaultMessage="Name"
                />
            </FormLabel>
            <Form.Group widths="equal">
                {map(languages, lang => (
                    <Form.Field
                        key={lang}
                        required={lang === defaultLanguage}
                        error={!!errors.nameVariants?.[lang]}
                    >
                        <FormLabel>{lang.toUpperCase()}</FormLabel>
                        <Controller
                            name={`nameVariants.${lang}`}
                            control={control}
                            render={({ field: { ref: _ref, ...field } }) => (
                                <Input {...field} fluid />
                            )}
                        />
                    </Form.Field>
                ))}
            </Form.Group>
            <Form.Group widths="equal">
                <Form.Field>
                    <FormLabel>
                        <FormattedMessage
                            id="pages.staff.form.clientForm.services"
                            defaultMessage="Services"
                        />
                    </FormLabel>
                    <Controller
                        name="serviceGroups"
                        control={control}
                        render={({ field: { ref: _ref, value, onChange, ...field } }) => (
                            <ServiceGroupSelect
                                {...field}
                                value={value || []}
                                onChange={(e, data) => onChange(data.value)}
                                multiple
                            />
                        )}
                    />
                </Form.Field>
            </Form.Group>
        </Form>
    );
}

export default CabinetForm;
